<template>
  <div class="form-group">
    <label :for="id">{{ label }}</label>
    <span v-if="helpText" class="form-group__helptext">{{ helpText }}</span>
    <select class="form-control" v-bind:class="{'is-invalid': baseInput.showErrors()}"
      :id="id"
      :aria-label="ariaLabelText ? ariaLabelText : false"
      v-model="inputVal"
      @focus="setFocus()"
      @blur="setBlur()">
      <option selected disabled value="">{{ defaultText }}</option>
      <template v-for="(option, index) in options">
        <option :key="index" :value="option[valueField]">
          {{ option[labelField] }}
        </option>
      </template>
    </select>
    <div class="invalid-feedback" v-if="baseInput.showErrors()">
      <span v-for="(error, index) in baseInput.errors()" v-bind:key="index">
        {{error}}
      </span>
    </div>
  </div>
</template>

<script>
import useBaseInput from 'client/js/composition/base-input'

export default {
  props: {
    label: { type: String },
    value: { type: String },
    id: { type: String },
    helpText: { type: String, default: null },
    ariaLabelText: { type: String, default: null },
    options: {
      type: Array,
      required: true
    },
    defaultText: {
      type: String,
      required: false,
      default: 'Select'
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    valueField: {
      type: String,
      required: false,
      default: 'value'
    },
    labelField: {
      type: String,
      required: false,
      default: 'label'
    },
    errors: {
      type: Array,
      required: false,
      default: []
    }
  },
  setup(props, context) {
    return {
      baseInput: useBaseInput(props, context)
    }
  },
  data() {
    return {
      // selected: this.defaultText ? this.defaultText : this.options.length > 0 ? this.options[0] : null
      selected: null
    }
  },
  computed: {
    inputVal: {
      get() {
        if (this.value != undefined) {
          return this.value
        } else {
          return ''
        }
      },
      set(value) {
        this.selected = value.toString()
        this.$emit('input', this.id, this.selected)
      }
    }
  },
  methods: {
    setFocus() {
      this.$emit('focusEmit', this.id)
    },
    setBlur() {
      this.baseInput.touched(true)
      this.$emit('blurEmit')
    }
  },
  mounted() {

  }
}
</script>
